import { motion } from "framer-motion";

export const BotanicalDivider = ({ className = "", width = 320 }) => (
    <motion.svg
        width={width}
        height="36"
        viewBox="0 0 320 36"
        className={className}
        initial={{ opacity: 0, scaleX: 0.6 }}
        whileInView={{ opacity: 1, scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        aria-hidden="true"
    >
        <line x1="8" y1="18" x2="118" y2="18" stroke="#C9A227" strokeWidth="0.8" opacity="0.8" />
        <line x1="202" y1="18" x2="312" y2="18" stroke="#C9A227" strokeWidth="0.8" opacity="0.8" />
        <g stroke="#C9A227" strokeWidth="0.8" fill="none" opacity="0.9">
            <path d="M118 18 q10 -10 22 -8" />
            <path d="M126 14 q4 -8 12 -9" />
            <ellipse cx="140" cy="6" rx="2.2" ry="4.6" transform="rotate(38 140 6)" />
            <path d="M202 18 q-10 -10 -22 -8" />
            <path d="M194 14 q-4 -8 -12 -9" />
            <ellipse cx="180" cy="6" rx="2.2" ry="4.6" transform="rotate(-38 180 6)" />
        </g>
        <path
            d="M160 25 c-5.5-7-14-3.5-14 3 c0 5 6.5 8.5 14 13.5 c7.5-5 14-8.5 14-13.5 c0-6.5-8.5-10-14-3z"
            transform="translate(0 -13)"
            fill="none"
            stroke="#C9A227"
            strokeWidth="1.1"
        />
        <circle cx="8" cy="18" r="1.6" fill="#C9A227" />
        <circle cx="312" cy="18" r="1.6" fill="#C9A227" />
    </motion.svg>
);

export const CornerFlourish = ({ className = "", flip = false }) => (
    <svg
        width="140"
        height="140"
        viewBox="0 0 140 140"
        className={className}
        style={flip ? { transform: "scaleX(-1)" } : undefined}
        aria-hidden="true"
    >
        <g stroke="#C9A227" fill="none" strokeWidth="0.9" opacity="0.55">
            <path d="M6 134 C 10 80, 40 40, 96 22" />
            <path d="M28 108 q-4 -16 6 -26" />
            <ellipse cx="38" cy="78" rx="3" ry="7" transform="rotate(28 38 78)" />
            <ellipse cx="58" cy="52" rx="3" ry="7" transform="rotate(40 58 52)" />
            <ellipse cx="84" cy="32" rx="3" ry="7" transform="rotate(56 84 32)" />
            <path d="M96 22 q14 -8 26 -4" />
            <circle cx="128" cy="17" r="2" fill="#C9A227" stroke="none" />
            <circle cx="20" cy="120" r="1.6" fill="#C9A227" stroke="none" />
        </g>
    </svg>
);
